/* pe-cart-patch.js v3 - Stock toast + button fixes + Samsung cart height.
   Pure ASCII only.

   Bugs fixed:
   1. Stock message: shows a toast when Shopify returns 422 (stock exceeded).
   2. Empty cart bug: 422 error previously called refreshCart(errorObject)
      which has no 'items' field, rendering cart as empty. Now we re-fetch.
   3. Buttons both disabled during in-flight request (race condition fix).
   4. refreshCart SVG fix: pe-cart.js renders qty buttons as text '+'/'-'
      but theme CSS uses font-size:0 on those buttons (designed for SVGs),
      making the '+' invisible after first renderCart call. We wrap
      window.renderCart to post-process and restore SVG icons.
*/
(function(){
  var t=0;

  /* -- Stock exceeded toast -------------------------------- */
  function peStockToast(msg){
    var id='pe-stock-toast';
    var old=document.getElementById(id);
    if(old){clearTimeout(old._t);old.remove();}

    if(!document.getElementById('pe-stock-css')){
      var s=document.createElement('style');
      s.id='pe-stock-css';
      s.textContent=
        '@keyframes peStIn{from{opacity:0;transform:translateX(-50%) translateY(10px)}'+
        'to{opacity:1;transform:translateX(-50%) translateY(0)}}';
      document.head.appendChild(s);
    }

    var el=document.createElement('div');
    el.id=id;
    el.setAttribute('role','alert');
    el.setAttribute('aria-live','assertive');
    el.style.cssText=
      'position:fixed;bottom:88px;left:50%;transform:translateX(-50%);'+
      'background:#b91c1c;color:#fff;'+
      'padding:11px 18px 11px 14px;border-radius:9px;'+
      'font-size:13px;font-weight:600;line-height:1.4;'+
      'z-index:100000;pointer-events:none;'+
      'display:flex;align-items:center;gap:9px;'+
      'max-width:calc(100vw - 32px);white-space:normal;'+
      'box-shadow:0 6px 24px rgba(0,0,0,.28);'+
      'animation:peStIn .24s ease both;';

    var icon=document.createElement('span');
    icon.style.cssText='flex-shrink:0;display:flex;align-items:center;';
    icon.innerHTML=
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" '+
      'stroke="currentColor" stroke-width="2.2" stroke-linecap="round">'+
      '<path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3'+
      'L13.71 3.86a2 2 0 00-3.42 0z"/>'+
      '<line x1="12" y1="9" x2="12" y2="13"/>'+
      '<line x1="12" y1="17" x2="12.01" y2="17"/>'+
      '</svg>';

    var txt=document.createElement('span');
    txt.textContent=msg||window.PE_T('max_stock','Maximum stock quantity reached');

    el.appendChild(icon);
    el.appendChild(txt);
    document.body.appendChild(el);

    el._t=setTimeout(function(){
      el.style.transition='opacity .35s';
      el.style.opacity='0';
      setTimeout(function(){if(el.parentNode)el.remove();},350);
    },3500);
  }

  /* -- SVG icons for qty buttons --------------------------- */
  /* pe-cart.js refreshCart renders:
       <button class="qty-step-btn" data-act="minus">-</button>
       <button class="qty-step-btn" data-act="plus">+</button>
     But the theme CSS was built for SVG-only buttons and may have
     font-size:0 on .qty-step-btn, making the text invisible.
     We wrap window.renderCart to replace text with correct SVGs. */
  var MINUS_SVG=
    '<svg width="10" height="2" viewBox="0 0 10 2" fill="none" '+
    'stroke="currentColor" stroke-width="2" stroke-linecap="round">'+
    '<line x1="0" y1="1" x2="10" y2="1"/></svg>';
  var PLUS_SVG=
    '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" '+
    'stroke="currentColor" stroke-width="2" stroke-linecap="round">'+
    '<line x1="5" y1="0" x2="5" y2="10"/>'+
    '<line x1="0" y1="5" x2="10" y2="5"/></svg>';

  function fixQtyIcons(root){
    (root||document).querySelectorAll('.qty-step-btn').forEach(function(btn){
      /* Only replace if the button contains plain text (not already an SVG) */
      if(btn.querySelector('svg')) return;
      var act=btn.getAttribute('data-act')||btn.dataset.act||'';
      if(act==='minus'){btn.innerHTML=MINUS_SVG;}
      else if(act==='plus'){btn.innerHTML=PLUS_SVG;}
    });
  }

  function patch(){
    if(!window.cartChange||!window.cartGet||!window.renderCart){
      if(++t<40) setTimeout(patch,250);
      return;
    }

    /* -- Wrap renderCart to fix SVG icons --- */
    var _origRender=window.renderCart;
    window.renderCart=function(data){
      _origRender(data);
      /* After the DOM is updated, replace text +/- with SVGs */
      var body=document.getElementById('cdBody');
      if(body) fixQtyIcons(body);
    };

    /* -- Patch cartChange ------------------ */
    window.cartChange=function(k,q,cb){
      /* Disable BOTH qty buttons for this item while the API is in-flight.
         Prevents race conditions from rapid clicking. */
      var btns=document.querySelectorAll('.qty-step[data-key="'+k+'"] .qty-step-btn');
      btns.forEach(function(b){b.disabled=true;});

      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({id:k,quantity:q})
      })
      .then(function(r){
        /* CRITICAL: check HTTP status before parsing.
           422 = stock exceeded. Without this check, refreshCart(errorObj)
           renders empty cart because errorObj has no 'items' field. */
        if(!r.ok){
          return r.json().then(function(d){
            var e=new Error(d.description||d.error||window.PE_T('stock_limit','Stock limit reached'));
            e.httpStatus=r.status;
            throw e;
          });
        }
        return r.json();
      })
      .then(function(d){window.renderCart(d);if(cb)cb(d);})
      .catch(function(e){
        /* Re-fetch real cart state: prevents empty cart bug AND
           re-enables buttons (renderCart creates fresh DOM). */
        window.cartGet(window.renderCart);
        /* Show message only for 422 (stock exceeded).
           Network errors are silent. */
        if(e&&e.httpStatus===422){
          peStockToast(e.message||window.PE_T('max_stock','Maximum stock quantity reached'));
        }
      });
    };

    /* Fix SVG icons that are already in the DOM on load */
    var body=document.getElementById('cdBody');
    if(body) fixQtyIcons(body);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',patch);
  }else{
    patch();
  }
})();
